import { OrganisationContext } from 'context'
import { useContext } from 'react'

const useOrganisation = () => useContext(OrganisationContext)

export { useOrganisation }
